import React from 'react';
import { twMerge } from 'tailwind-merge';

export const EditIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  onClick,
  color = '#9EC3E4',
  height = 20,
  width = 19,
  className,
}) => (
  <svg
    className={twMerge(`fill-[${color}]`, className)}
    onClick={onClick}
    width={width}
    height={height}
    viewBox="0 0 19 20"
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.985 1.25493L17.9625 1.23436C17.5312 0.840479 16.9723 0.623535 16.3885 0.623535C15.7341 0.623535 15.1058 0.900569 14.6646 1.38354L6.32237 10.5166C6.24633 10.5998 6.18866 10.698 6.153 10.8049L5.17208 13.7456C5.05867 14.0856 5.11559 14.4616 5.32432 14.7513C5.53471 15.0433 5.87366 15.2177 6.23108 15.2177C6.38568 15.2177 6.53685 15.1859 6.68017 15.1232L9.52031 13.8807C9.62358 13.8355 9.71621 13.7692 9.79219 13.686L18.1344 4.55302C19.0025 3.60271 18.9356 2.1233 17.985 1.25493ZM7.0515 13.2024L7.6271 11.4768L7.67564 11.4237L8.76659 12.4201L8.71805 12.4733L7.0515 13.2024ZM16.945 3.46653L9.85309 11.2307L8.76214 10.2343L15.8541 2.47003C15.9928 2.31817 16.1826 2.23451 16.3886 2.23451C16.5693 2.23451 16.7424 2.30174 16.8763 2.42406L16.8988 2.44463C17.1933 2.71361 17.214 3.17204 16.945 3.46653Z" />
    <path d="M16.3664 8.0551C15.9215 8.0551 15.5609 8.41574 15.5609 8.86058V15.699C15.5609 16.8285 14.642 17.7475 13.5124 17.7475H3.75001C2.62045 17.7475 1.70155 16.8285 1.70155 15.699V6.01588C1.70155 4.88637 2.6205 3.96742 3.75001 3.96742H10.8161C11.2609 3.96742 11.6216 3.60677 11.6216 3.16193C11.6216 2.71709 11.2609 2.35645 10.8161 2.35645H3.75001C1.73216 2.35645 0.0905762 3.99808 0.0905762 6.01588V15.6989C0.0905762 17.7167 1.73221 19.3584 3.75001 19.3584H13.5124C15.5302 19.3584 17.1718 17.7167 17.1718 15.6989V8.86058C17.1719 8.41574 16.8112 8.0551 16.3664 8.0551Z" />
  </svg>
);
